<template>
  <div class="siteContainer">
    <header>
      <div class="row">
        <div class="col between">
          <a
            class="branding"
            href="https://www.pkw.de/"
            title="Zurück zur Startseite von PKW.de"
          >
            <img
              src="https://www.pkw.de/./assets/images/biglogo.png"
              alt="PKW.de - Finde den besten Preis"
            />
          </a>
          <a
            class="priceEvaluationBtn"
            href="https://www.pkw.de/auto-verkaufen/"
            title="Willst du wissen, was dein Auto wert ist?"
          >
            Kostenlose Fahrzeugbewertung
          </a>
        </div>
      </div>
    </header>
    <div class="searchContainer">
      <div class="row center">
        <div class="col">
          <h1>Hoppla! Seite nicht gefunden!</h1>
          <h2>Es tut uns leid, aber die gewünschte Seite existiert nicht.</h2>
        </div>
      </div>
    </div>
    <main class="mainContent">
      <div class="row">
        <div class="col">
          <h3>Jetzt Gebrauchtwagen finden!</h3>
          <form class="search-form">
            <label class="select-label brand-select">
              <p class="input-title">Marke</p>
              <select id="hp-search-brand" name="brand" class="custom-select">
                <option value="">alle Marken</option>
                <option value="49">Mercedes-Benz</option>
                <option value="76">VW</option>
                <option value="9">BMW</option>
                <option value="6">Audi</option>
                <option value="54">Opel</option>
              </select>
            </label>
            <label class="select-label hp-select-model">
              <p class="input-title">Modell</p>
              <select
                id="hp-search-model"
                name="model"
                disabled=""
                class="custom-select"
              >
                <option value="">alle Modelle</option>
              </select>
            </label>
            <button class="search-btn">Autosuche starten</button>
          </form>
        </div>
      </div>
    </main>
    <section class="channelOverview">
      <div class="row">
        <div class="col small-6">
          <a
            href="https://suche.pkw.de/fahrzeuge"
            title="Jetzt Fahrzeug auf PKW.de finden"
            class="error_content"
          >
            <span class="headline">Fahrzeugsuche</span>
            <span class="showText"
              >Du suchst ein Fahrzeug? Hier gelangst du zu den Gebrauchtwagen
              auf PKW.de mit Preis-Check.
            </span>
            <img
              src="./assets/images/404_page/teaser/fahrzeugsuche.jpg"
              alt="PKW.de Fahrzeugsuche"
          /></a>
        </div>
        <div class="col small-6">
          <a
            href="https://www.pkw.de/autohaus/"
            title="Finden Sie den passenden Autohändler in Ihrer Region"
            class="error_content"
          >
            <span class="headline">Händlersuche</span>
            <span class="showText"
              >Finde den passenden Autohändler in deiner Region.</span
            >
            <img
              src="./assets/images/404_page/teaser/autohaendler.jpg"
              alt="PKW.de Händlersuche"
          /></a>
        </div>
        <div class="col small-6 medium-4">
          <a
            href="https://www.pkw.de/magazin/"
            title="Neuste Artikel im PKW.de Magazin"
            class="error_content"
          >
            <span class="headline">Magazin</span>
            <span class="showText"
              >Die neusten Artikel rund um das Thema Auto &amp; Auto verkaufen
              im PKW.de Magazin.</span
            >
            <img
              src="./assets/images/404_page/teaser/ratgeber.jpg"
              alt="PKW.de Magazin"
          /></a>
        </div>
        <div class="col small-6 medium-4">
          <a
            href="https://www.pkw.de/autokatalog/"
            title="ALLE MARKEN AUF EINEN BLICK"
            class="error_content"
          >
            <span class="headline">Autokatalog</span>
            <span class="showText"
              >In dem PKW.de Autokatalog finden Sie alle Fahrzeugmarken auf
              einen Blick.
            </span>
            <img
              src="./assets/images/404_page/teaser/autokatalog.jpg"
              alt="PKW.de Autokatalog"
          /></a>
        </div>
        <div class="col small-6 medium-4">
          <a
            href="https://www.pkw.de/auto-verkaufen/"
            title="Finde den besten Preis auf PKW.de"
            class="error_content last"
          >
            <span class="headline">Fahrzeugbewertung</span>
            <span class="showText"
              >Was ist dein Fahrzeug wert? Nutze unsere kostenlose
              Fahrzeugbewertung.
            </span>
            <img
              src="./assets/images/404_page/teaser/fahrzeugbewertung.jpg"
              alt="kostenlose PKW.de Fahrzeugbewertung"
          /></a>
        </div>
      </div>
    </section>
    <footer>
      <div class="row center">
        <div class="col">
          <div class="line"></div>
          <ul class="naviAdd">
            <li>
              <a href="https://www.pkw.de/" title="zurück zur Startseite"
                >Startseite</a
              >
            </li>
            <li>
              <a href="https://www.pkw.de/kontakt/" title="Haben Sie Fragen?"
                >Kontakt</a
              >
            </li>
            <li>
              <a href="https://www.pkw.de/agb/" title="mehr erfahren">AGB</a>
            </li>
            <li>
              <a href="https://www.pkw.de/impressum/" title="mehr erfahren"
                >Impressum</a
              >
            </li>
            <li>
              <a href="https://www.pkw.de/datenschutz/" title="mehr erfahren"
                >Datenschutz</a
              >
            </li>
          </ul>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>

export default {
  name: "ErrorPage",
  mounted () {
    "use strict";
function _instanceof(e, t) {
  return null != t && "undefined" != typeof Symbol && t[Symbol.hasInstance]
    ? t[Symbol.hasInstance](e)
    : e instanceof t;
}
function _classCallCheck(e, t) {
  if (!_instanceof(e, t))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    (r.enumerable = r.enumerable || !1),
      (r.configurable = !0),
      "value" in r && (r.writable = !0),
      Object.defineProperty(e, r.key, r);
  }
}
function _createClass(e, t, n) {
  return (
    t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e
  );
}
var SearchForm = (function () {
    function e() {
      _classCallCheck(this, e),
        (this.API_URL = "https://www.pkw.de/api/v1"),
        (this.SEARCH_URL = "https://suche.pkw.de/fahrzeuge"),
        (this.brandSelect = document.querySelector("#hp-search-brand")),
        (this.modelsSelect = document.querySelector("#hp-search-model")),
        (this.searchForm = document.querySelector(".search-form"));
    }
    return (
      _createClass(e, [
        {
          key: "fetchModels",
          value: function () {
            var n = this;
            
            this.brandSelect.onchange = function () {
              var e = n.brandSelect.value;
              if (!e)
                return (
                  n.clearOptions(),
                  void n.modelsSelect.setAttribute("disabled", "disabled")
                );
              var t = n.API_URL + "/brands/".concat(e, "/models");
              return fetch(t)
                .then(function (e) {
                  return e.json();
                })
                .then(function (e) {
                  return e.models;
                })
                .then(function (e) {
                  return n.fillOptions(e);
                });
            };
          },
        },
        {
          key: "fillOptions",
          value: function (e) {
            var r = this;
            this.clearOptions(),
              (this.modelsSelect.disabled = !1),
              e.forEach(function (e) {
                var t = document.createElement("option"),
                  n = document.createTextNode(e.name);
                t.setAttribute("value", e.id),
                  t.appendChild(n),
                  r.modelsSelect.appendChild(t);
              });
          },
        },
        {
          key: "clearOptions",
          value: function () {
            this.modelsSelect.length = 1;
          },
        },
        {
          key: "handleSearch",
          value: function () {
            var n = this;
            this.searchForm.addEventListener("submit", function (e) {
              e.preventDefault();
              var t = n.SEARCH_URL;
              n.brandSelect.value &&
                ((t += "?brand_model=".concat(n.brandSelect.value)),
                n.modelsSelect.value &&
                  (t += "_".concat(n.modelsSelect.value))),
                (window.location.href = t);
            });
          },
        },
        {
          key: "init",
          value: function () {
            this.fetchModels(), this.handleSearch();
          },
        },
      ]),
      e
    );
  })(),
  formHandler = new SearchForm();
formHandler.init();

  }
};
</script>

<style scoped>
*,
.col {
  box-sizing: border-box;
}
.error_content img,
.error_content span,
a {
  transition: all 0.5s;
}
* {
  padding: 0;
  margin: 0;
  outline: 0;
}
body {
  background: #f6f6fb;
  color: #3d3d3d;
  font-family: Asap, sans-serif;
  font-style: 18px;
  font-weight: 400;
  overflow-x: hidden;
}
img {
  max-width: 100%;
}
h1 {
  font-weight: 600;
  font-size: 24px;
  margin-bottom: 10px;
}

h2:before {
  display: none;
}

h2,
h3 {
  font-weight: 400;
  margin-bottom: 20px;
}
@media (min-width: 480px) {
  h1 {
    font-size: 32px;
  }
}
@media (min-width: 992px) {
  h1 {
    margin-bottom: 2rem;
  }
}
h2 {
  font-size: 18px;
}
@media (min-width: 480px) {
  h2 {
    font-size: 22px;
  }
}
h3 {
  font-size: 24px;
}
.row,
.siteContainer {
  max-width: 1220px;
  margin: 0 auto;
}
a {
  cursor: pointer;
}
.row {
  width: 100%;
  position: relative;
  display: flex;
  flex: 0 1 auto;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
}
.row.center {
  align-items: center;
  justify-content: center;
  text-align: center;
}
.col {
  float: left;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  flex: 0 0 auto;
  flex-grow: 1;
  flex-basis: 100%;
}
@media (min-width: 480px) {
  h3 {
    font-size: 26px;
    font-weight: 700;
  }
  .col.between {
    justify-content: space-between;
    display: flex;
    align-items: center;
  }
  .col.small-6 {
    width: 50%;
    flex-basis: 50%;
  }
}
@media (min-width: 992px) {
  .col.medium-4 {
    width: 33%;
    flex-basis: 33%;
  }
}
.siteContainer {
  background: #fff;
  width: 100%;
  height: 100%;
}
header {
  padding: 2rem 0;
}
header .branding {
  max-width: 126px;
  display: block;
  margin-bottom: 1rem;
}
@media (min-width: 480px) {
  header .branding {
    margin-bottom: 0;
  }
}
header .priceEvaluationBtn {
  background: $blue;
  height: 60px;
  color: #fff;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-size: 13px;
  text-decoration: none;
}
header .priceEvaluationBtn:before {
  content: "";
  display: block;
  width: 34px;
  height: 25.2px;
  background: url(assets/images/avto-price-icon.png) no-repeat;
  background-size: cover;
  margin-right: 15px;
}
header .priceEvaluationBtn:hover {
  background: #185291;
}
.searchContainer {
  background: url(assets/images/404_page/bg-searchContainer.jpg) no-repeat fixed;
  background-size: cover;
  padding: 4rem 0;
  color: #fff;
  margin-bottom: 2rem;
}
@media (min-width: 992px) {
  header .priceEvaluationBtn {
    font-size: 16px;
  }
  .searchContainer {
    height: 220px;
    display: flex;
    margin-bottom: 4rem;
  }
}
.searchContainer h1 {
  margin-bottom: 10px;
}
.searchContainer .searchBox {
  position: relative;
  display: inline-block;
}
.searchContainer .searchBox:hover .searchResults {
  display: block;
}
.searchContainer .searchBox .searchResults {
  display: none;
  position: absolute;
  top: 65px;
  left: 0;
  background: #fff;
  width: 100%;
  color: #3d3d3d;
  text-align: left;
  height: 90px;
  overflow-y: scroll;
}
.searchContainer .searchBox:before,
.searchContainer button:before {
  position: absolute;
  left: 25px;
  content: "";
}
.searchContainer .searchBox .searchResults ul {
  list-style-type: none;
}
.searchContainer .searchBox .searchResults ul li {
  border-bottom: 1px solid #f6f6fb;
  padding: 15px;
}
.searchContainer .searchBox .searchResults ul li:hover {
  background: #f6f6fb;
  cursor: pointer;
}
.searchContainer .searchBox:before {
  display: block;
  top: 20px;
  width: 23px;
  height: 23px;
  background: url(assets/images/404_page/search.svg) no-repeat;
  opacity: 0.3;
}
.searchContainer input {
  display: inline-block;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 20px 30px 20px 60px;
  font-size: 20px;
  color: #fff;
  background: 0 0;
  outline: 0;
  font-weight: 400;
}
.searchContainer button {
  cursor: pointer;
  height: 65px;
  width: 65px;
  position: absolute;
  top: 0;
  right: 0;
  background: 0 0;
  text-indent: -9999rem;
  border: none;
  outline: 0;
}
.searchContainer button:before {
  display: block;
  top: 20px;
  width: 23px;
  height: 23px;
  background: url(assets/images/404_page/arrow.svg) no-repeat;
  transition: all 0.5s;
}
.searchContainer button:hover:before {
  opacity: 0.4;
}
.channelOverview {
  margin: 2rem 0;
}
@media (min-width: 992px) {
  .searchContainer input {
    padding-right: 100px;
  }
  .channelOverview {
    margin: 4rem 0 2rem;
  }
}
.error_content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem;
  height: 120px;
  background: #000;
  position: relative;
  color: #fff;
  text-decoration: none;
  font-size: 20px;
  text-align: center;
  margin-bottom: 2rem;
  overflow: hidden;
}
.error_content img {
  opacity: 0.4;
  position: absolute;
  top: 0;
  left: 0;
}
@media (min-width: 992px) {
  .error_content {
    height: 200px;
    padding: 3rem 2rem 2rem;
  }
  .error_content.last:hover {
    background: $blue;
  }
  .error_content.last:hover img {
    overflow: 0.1;
  }
  .error_content img {
    opacity: 0.1;
  }
  .error_content:hover {
    padding: 2rem;
  }
  .error_content span {
    font-size: 30px;
  }
}
.error_content:hover img {
  transform: scale(1.2);
  opacity: 0.4;
}
.error_content:hover.last img {
  opacity: 0.1;
}
.error_content:hover span {
  text-shadow: 1px 1px 5px rgba(61, 61, 61, 0.8);
}
.error_content span {
  position: relative;
  display: inline-block;
  z-index: 1;
}
.error_content span.showText {
  font-size: 14px;
  font-weight: 400;
  display: none;
}
@media (min-width: 992px) {
  .error_content span.showText {
    display: block;
    opacity: 1;
    visibility: visible;
    transition: all 0.5s;
    max-width: 80%;
    position: relative;
    margin: 0 auto;
    font-size: 16px;
    line-height: 22px;
  }
}
@media (min-width: 640px) {
  .error_content {
    height: 200px;
  }
  form {
    display: flex;
    justify-content: space-between;
    align-items: end;
  }
}
.line,
form .search-btn,
form button,
form label {
  display: block;
}
form p {
  margin-bottom: 5px;
}
form label {
  margin-bottom: 20px;
  position: relative;
}
@media (min-width: 640px) {
  form label {
    margin-bottom: 0;
    width: 30%;
  }
}
form .search-btn,
form select {
  height: 50px;
  width: 100%;
  font-weight: 700;
  position: relative;
}
form select {
  border: 1px solid #ababab;
  background: #fff;
  line-height: 24px;
  padding: 5px 10px;
  border-radius: 0;
}
form .search-btn {
  outline: 0 !important;
  border: 0 !important;
  background-color: #c0141b !important;
  cursor: pointer !important;
  transition-property: background-color !important;
  transition-duration: 0.3s !important;
  transition-timing-function: ease !important;
  font-size: 16px !important;
  color: #fff !important;

  padding: 0 0 0 25px !important;
  border-radius: 0 !important;
}
form .search-btn:hover {
  background: #84090e;
}
form .search-btn:before {
  content: "";
  position: absolute;
  display: block;
  top: 13px;
  left: 25px;
  width: 23px;
  height: 23px;
  background: url(assets/images/404_page/search.svg) no-repeat;
}
@media (min-width: 640px) {
  form .search-btn {
    width: 30%;
  }
}
.line {
  height: 1px;
  background: #dadada;
  width: 100%;
  margin: 2rem 0;
}
.naviAdd {
  list-style: none;
  max-width: 500px;
  margin: 0 auto 2rem;
}
.naviAdd li {
  margin-bottom: 10px;
}
.naviAdd li a {
  color: rgba(61, 61, 61, 0.5);
  text-decoration: none;
}
@media (min-width: 480px) {
  .naviAdd {
    display: flex;
    justify-content: space-between;
  }
  .naviAdd li a {
    font-size: 13px;
  }
}
@media (min-width: 992px) {
  .naviAdd li a {
    font-size: 16px;
  }
}
.naviAdd li a:hover {
  color: #d10107;
}

.select-label::after {
  top: 42px;
}
</style>



// WEBPACK FOOTER //
// src/ErrorPage.vue